import { render, staticRenderFns } from "./SelectedPackages.vue?vue&type=template&id=27f51706&scoped=true&"
import script from "./SelectedPackages.vue?vue&type=script&lang=js&"
export * from "./SelectedPackages.vue?vue&type=script&lang=js&"
import style0 from "./SelectedPackages.vue?vue&type=style&index=0&id=27f51706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f51706",
  null
  
)

export default component.exports